import MersenneTwister from "mersenne-twister"
import { fromIndex, Tile, toIndex } from '../tile'
import { distance } from './distance'

function defaultSeed()
{
    const now = new Date()
    return [
        now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
        //now.getHours(), now.getMinutes(), Math.floor(now.getUTCSeconds() / 10) // for development
    ]
}
// randomHandPlus and randomHand are intentionally not uniform:
// Increased probability of getting more than one tiles of a kind should result in generating interesting hands.
export function randomHandPlus()
{
    let maxTrial = 100

    let hand: number[] = Array(35).fill(0)
    hand[34] = 4
    let index: number[] = []

    let mt = new MersenneTwister(defaultSeed())
    const td = [2, 3, 3, 4, 4, 4][mt.random_int() % 6]

    for (let i = 0; i < 14; i++)
    {
        let t = 34
        while (hand[t] === 4)
            t = mt.random_int() % 34
        index.push(t)
        hand[t] += 1
    }
    let cd = distance(hand)
    while (cd !== td)
    {
        if (--maxTrial < 0)
            throw new Error("maxtrial exceeded")
        // discard one
        let position = mt.random_int() % 14
        hand[index[position]] -= 1

        // draw one
        let t = 34
        while (hand[t] === 4)
            t = mt.random_int() % 34
        hand[t] += 1

        // calculate
        let nd = distance(hand)
        if (nd <= cd || nd <= td)
        {
            // accept
            index[position] = t
            cd = nd
            continue
        }

        // undo
        hand[t] -= 1
        hand[index[position]] += 1
    }
    return fromCounts(hand)
}
export function randomHand()
{
    let hand: Tile[] = []
    let seen: number[] = new Array(35).fill(0)
    seen[34] = 4
    let mt = new MersenneTwister(defaultSeed())
    for (let i = 0; i < 14; i++)
    {
        let t = 34
        while (seen[t] === 4)
        {
            t = mt.random_int() % 34
        }
        seen[t] += 1
        hand.push(fromIndex(t))
    }
    return hand.sort((a, b) => toIndex(a) - toIndex(b))
}
export function asCounts(hand: Tile[])
{
    let ret = Array(34).fill(0)
    hand.forEach((tile) => ret[toIndex(tile)]++)
    return ret
}
export function fromCounts(hand: number[])
{
    let ret: Tile[] = []
    hand.slice(0, 34).forEach((c, t) =>
    {
        for (let i = 0; i < c; ++i)
            ret.push(fromIndex(t))
    })
    return ret
}
export function toReadable(hand: Tile[])
{
    let nums: {w: number[], t: number[], b: number[]} = {w: [], t: [], b: []}
    let hons = ""
    hand.forEach((tile) => {switch (tile.kind)
    {
        case "w": case "b": case "t":
            nums[tile.kind].push(tile.rank)
        break; case "f":
            hons += {
                1: "東",
                2: "南",
                3: "西",
                4: "北",
            }[tile.rank as 1|2|3|4]
        break; case "j":
            hons += {
                1: "中",
                2: "発",
                3: "白",
            }[tile.rank as 1|2|3]
    }
    })
    return suits(nums) + hons
}
function suits(hand: {w: number[], t: number[], b: number[]})
{
    let ret = ""
    let key: keyof typeof hand
    const append = (v: number) => {ret += v.toString()}
    for (key in hand)
    {
        hand[key].forEach(append)
        if (hand[key].length)
            ret += {w: "m", t: "s", b: "p"}[key]
    }
    return ret
}
